// 注册全局组件
export default function(Vue){
    Vue.component('MultCityAsync', () => import('@/components/MiltDistAsync.vue'))
    Vue.component('ad-button', () => import('@/components/BaseAdvButton.vue'))
    Vue.component('main-right', () => import('@/components/MainRightBody.vue'))
    Vue.component('fix-center', () => import('@/components/LayoutFixedCenter.vue'))
    Vue.component('fix-centerv1', () => import('@/components/LayoutFixedCenterModel.vue'))
    Vue.component('BaseFixCenter', () => import('@/components/BaseFixCenter.vue'))
}
